// Product catalog for Earth Tone Original Skin
export const ETSY_SHOP_URL = "https://www.etsy.com/shop/EarthToneOrginalSkin";

export const products = [
  {
    id: "melanin-tee",
    name: "The Power of Melanin",
    subtitle: "EarthTone Tee · Genesis 2:7",
    price: "$24.99",
    tag: "Bestseller",
    image: "https://i.etsystatic.com/67061944/r/il/90b2f1/8317502589/il_794xN.8317502589_nrd7.jpg",
    accent: "#c62828",
    accentLabel: "MIND",
    quote: "The pigment is the point.",
    url: "https://www.etsy.com/listing/4540175543/the-power-of-melanin-t-shirt-melanin",
  },
  {
    id: "original-goddess-tee",
    name: "Original Skin Goddess",
    subtitle: "EarthTone Boho Afro Tee",
    price: "$24.00",
    tag: "New Drop",
    image: "https://i.etsystatic.com/67061944/r/il/9a60d7/8276517860/il_794xN.8276517860_17j1.jpg",
    accent: "#c28b46",
    accentLabel: "BODY",
    quote: "She remembered her name.",
    url: "https://www.etsy.com/listing/4541081122/original-skin-goddess-tee-boho-afro",
  },
  {
    id: "dust-goddess-tee",
    name: "Formed From The Dust",
    subtitle: "Goddess Tee · Genesis 2:7",
    price: "$24.99",
    tag: "Genesis 2:7",
    image: "https://i.etsystatic.com/67061944/r/il/959f45/8324432567/il_794xN.8324432567_3dw7.jpg",
    accent: "#2c8a3e",
    accentLabel: "EARTH",
    quote: "Made from the ground she walks on.",
    url: "https://www.etsy.com/listing/4541088698/formed-from-the-dust-goddess",
  },
  {
    id: "dust-hoodie",
    name: "Formed From The Dust",
    subtitle: "EarthTone Hoodie · Genesis 2:7",
    price: "$24.00",
    tag: "Signature",
    image: "https://i.etsystatic.com/67061944/r/il/de932a/8275586854/il_794xN.8275586854_tvd9.jpg",
    accent: "#c28b46",
    accentLabel: "SIGNATURE",
    quote: "The cosmic blueprint, worn.",
    url: "https://www.etsy.com/listing/4540947622/formed-from-the-dust-male-genesis-27",
  },
  {
    id: "egyptian-tee",
    name: "Remember Who You Are",
    subtitle: "Egyptian Goddess EarthTone Tee",
    price: "$20.99",
    tag: "Limited",
    image: "https://i.etsystatic.com/67061944/r/il/c0019e/8273352216/il_794xN.8273352216_bgq6.jpg",
    accent: "#c28b46",
    accentLabel: "MIND",
    quote: "The pharaohs are your grandmothers.",
    url: "https://www.etsy.com/listing/4540684522/remember-who-you-are-egyptian-goddess",
  },
  {
    id: "cosmic-radiant-male",
    name: "Remember Who You Are",
    subtitle: "Cosmic Radiant Male EarthTone Tee",
    price: "$20.99",
    tag: "New Drop",
    image: "https://i.etsystatic.com/67061944/r/il/1f3906/8269657456/il_794xN.8269657456_20z7.jpg",
    accent: "#c62828",
    accentLabel: "MIND",
    quote: "The radiance was always yours.",
    url: "https://www.etsy.com/listing/4540181969/remember-who-you-are-male-cosmic-radiant",
  },
  {
    id: "behold-source",
    name: "Original Skin",
    subtitle: "Behold The Source · EarthTone Tee",
    price: "$24.00",
    tag: "Foundation",
    image: "https://i.etsystatic.com/67061944/r/il/95fd69/8276556354/il_794xN.8276556354_lpbo.jpg",
    accent: "#2c8a3e",
    accentLabel: "EARTH",
    quote: "Trace the root. Behold the source.",
    url: "https://www.etsy.com/listing/4541092878/original-skin-behold-the-source-tee-tree",
  },
];

export const socialLinks = {
  instagram: "https://instagram.com/earthtonearchetypes2025",
  tiktok: "https://tiktok.com/@earthtonearchetypes",
  youtube: "https://youtube.com/@EarthToneArchetypes",
  x: "https://x.com/EarthToneA40596",
  facebook: "https://facebook.com/profile.php?id=61589618184311",
  etsy: ETSY_SHOP_URL,
};

export const YT_VIDEO_ID = "ZL-9K2eJAxE";
